import { createSlice } from "@reduxjs/toolkit";

export interface DashboardState {
  bestsellerItems: {};
  bestsellerCategories: {};
  bestsellerSubCategories: {};
  saleStatusData: {},
  bestsellerBranches: {};
  bestsellerBrands: {};
  salesOverview: {};
  parameters: {};
  channelReport: {};
  salesByPaymentMode: {};
  salesByRevenue: [];
  salesDiscounts: [];
  onlineSales: [];
  dashboardFilterState: {
    [key:string]:any
  };
  sellingPriceDetail: {},
  sellTransactionData: {}
  isOverviewFetching: boolean,
  currentSale: [],
  oosItems: [],
  lastUpdate: ''
}

const initialState: DashboardState = {
  isOverviewFetching: false,
  bestsellerItems: {},
  bestsellerCategories: {},
  bestsellerSubCategories: {},
  saleStatusData: {},
  bestsellerBranches: {},
  bestsellerBrands: {},
  salesOverview: {},
  parameters: {},
  channelReport: {},
  salesByPaymentMode: {},
  salesByRevenue: [],
  salesDiscounts: [],
  onlineSales: [],
  dashboardFilterState: {},
  sellingPriceDetail: {},
  sellTransactionData: {},
  currentSale: [],
  oosItems: [],
  lastUpdate: ''
}

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    getBestsellersData: (state, actions) => {
      
    },
    getRankingsData: (state, actions) => {
      
    },
    getSalesOverviewData: (state, actions) => {
        state.isOverviewFetching = true
    },
    getParametersData: (state, actions) => {

    },
    getChannelReportData: (state, actions) => {

    },
    getSalesByPaymentModeData: (state, actions) => {
      
    },
    getSalesByRevenueData: (state, actions) => {
      
    },
    getOnlineSalesData: (state, actions) => {
      
    },
    getSalesDiscountsData: (state, actions) => {
      
    },
    getSalesStatusData: (state, actions) => {

    },
    getAvgSellingPrice: (state,actions) => {

    },
    getSalesTransactions: (state,actions) => {

    },
    getCurrentSale: (state, action) => {

    },
    getOOSItems: (state,action) => {

    },
    saveOOSItems: (state, action) => {
      state.oosItems = action.payload || []
    },
    saveCurrentSale: (state, action) => {
      state.currentSale = action.payload
    },
    saveSalesTransactions: (state, actions) => {
      state.sellTransactionData = actions.payload
    },
    saveAvgSellingPrice: (state,actions) => {
      state.sellingPriceDetail = actions.payload
    },
    saveBestsellerItemsData: (state, actions) => {
      state.bestsellerItems = actions.payload;
    },
    saveBestsellerCategoriesData: (state, actions) => {
      state.bestsellerCategories = actions.payload;
    },
    saveBestsellerSubCategoriesData: (state, actions) => {
      state.bestsellerSubCategories = actions.payload;
    },
    saveSalesStatusData: (state, actions) => {
      state.saleStatusData = actions.payload;
    },
    saveBestsellerBranchesData: (state, actions) => {
      state.bestsellerBranches = actions.payload;
    },
    saveBestsellerBrandsData: (state, actions) => {
      state.bestsellerBrands = actions.payload;
    },
    saveSalesOverviewData: (state, actions) => {
      state.salesOverview = actions.payload;
      state.isOverviewFetching = false
    },
    saveParametersData: (state, actions) => {
      state.parameters = actions.payload?.parameters || [];
    },
    saveSalesByPaymentModeData: (state, actions) => {
      state.salesByPaymentMode = actions.payload;
    },
    saveSalesByRevenueData: (state, actions) => {
      state.salesByRevenue = actions.payload?.list || [];
    },
    saveOnlineSalesData: (state, actions) => {
      state.onlineSales = actions.payload?.list || [];
    },
    saveSalesDiscountsData: (state, actions) => {
      state.salesDiscounts = actions.payload?.list || [];
    },
    saveDashboardFilterState: (state, actions) => {
      state.dashboardFilterState = {
        ...state.dashboardFilterState,
        [actions.payload.key]:actions.payload.value
      };
    },
    saveRealTimeLastUpdate: (state, action) => {
       state.lastUpdate = action.payload
    }
  }
})

export const {
  getBestsellersData,
  getRankingsData,
  getSalesOverviewData,
  getParametersData,
  getChannelReportData,
  getSalesByPaymentModeData,
  getSalesByRevenueData,
  getOnlineSalesData,
  getSalesDiscountsData,
  getSalesStatusData, 
  getAvgSellingPrice,
  getSalesTransactions,

  saveBestsellerItemsData,
  saveBestsellerCategoriesData,
  saveBestsellerSubCategoriesData,
  saveSalesStatusData,
  saveBestsellerBranchesData,
  saveBestsellerBrandsData,
  saveSalesOverviewData,
  saveParametersData,
  // saveChannelReport,
  saveSalesByPaymentModeData,
  saveSalesByRevenueData,
  saveOnlineSalesData,
  saveSalesDiscountsData,

  saveDashboardFilterState,
  saveAvgSellingPrice,
  saveSalesTransactions,
  getCurrentSale,
  saveCurrentSale,
  getOOSItems,
  saveOOSItems,
  saveRealTimeLastUpdate
} = dashboardSlice.actions;
export default dashboardSlice.reducer;